import React, { useEffect, useState, useContext } from "react";
import * as CGV from 'cgview';
import {useParams} from "react-router-dom";
import fetchOptionsBuilder from "../fetchOptionBuilder";
import WorkflowContext from "../workflowContext";
// import { useCookies } from "react-cookie";
import '../styles/pages/cgview.scss'

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

const CgView = () => {
    const workflow = useContext(WorkflowContext);
    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const [cgvData, setCgvData] = useState(null);
    const [buttons, setButtons] = useState([]);

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));  

    // const loadCgv = () => {
    //     const cgv = new CGV.Viewer('#my-viewer', {
    //         height: 500,
    //         width: 500,
    //         sequence: {
    //           length: 1000
    //         }
    //     });
        
        
    //     cgv.addFeatures({
    //         type: 'CDS',
    //         name: 'Feature',
    //         start: 100,
    //         stop: 250,
    //         strand: 1,
    //         source: 'genome-features',
    //         legend: 'CDS'
    //     });
        
    //     cgv.addFeatures({
    //         type: 'CDS',
    //         name: 'Another Feature',
    //         start: 400,
    //         stop: 750,
    //         strand: -1,
    //         source: 'genome-features',
    //         legend: 'CDS'
    //     });
        
        
    //     const legendItem = cgv.legend.items(1);
    //     legendItem.color = 'green';
    //     legendItem.decoration = 'arrow';
        
        
    //     const plot = new CGV.Plot(cgv, {
    //         positions: [50, 200, 400, 500, 600, 800],
    //         scores: [0.4, 0.75, 0.25, 0.5, 0.6, 0.1],
    //         baseline: 0.5,
    //         source: 'genome-plot',
    //         legendPositive: new CGV.LegendItem(cgv.legend, {swatchColor: 'blue', name: 'Plot +'}),
    //         legendNegative: new CGV.LegendItem(cgv.legend, {swatchColor: 'red', name: 'Plot -'})
    //     });
        
        
    //     cgv.addTracks({
    //         name: 'My Feature Track',
    //         separateFeaturesBy: 'strand',
    //         position: 'both',
    //         dataType: 'feature',
    //         dataMethod: 'source',
    //         dataKeys: 'genome-features'
    //     });
        
        
    //     cgv.addTracks({
    //         name: 'My Plot Track',
    //         position: 'inside',
    //         dataType: 'plot',
    //         dataMethod: 'source',
    //         dataKeys: 'genome-plot'
    //     });
        
    //     cgv.draw();

        
        
    // }

    let {id} = useParams();

    useEffect(() => {
        // loadCgv();
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `cgview/${id}`, fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            // fetch('https://js.cgview.ca/data/json/CP021212.json')
            .then(response => response.json())
            .then(json => setCgvData(json));
    }, []);

    
    useEffect(() => {
        // Clear viewer div
        document.getElementById('my-viewer').innerHTML = '';

        // Create the viewer
        const cgv = new CGV.Viewer('#my-viewer', {
            height: 700,
            width: 700,
        });

        // Load the JSON
        cgv.io.loadJSON(cgvData);

        const newButtons = [
            <div className="cgv-btn" id="btn-reset" title="Reset Map" onClick={() => cgv.reset()}></div>,
            <div className="cgv-btn" id="btn-zoom-in" title="Zoom In" onClick={() => cgv.zoomIn()}></div>,
            <div className="cgv-btn" id="btn-zoom-out" title="Zoom Out" onClick={() => cgv.zoomOut()}></div>,
            <div className="cgv-btn" id="btn-move-left" title="Move Left/Counterclockwise" onClick={() => cgv.moveLeft()}></div>,
            <div className="cgv-btn" id="btn-move-right" title="Move Right/Clockwise" onClick={() => cgv.moveRight()}></div>,
            <div className="cgv-btn" id="btn-toggle-format" title="Toggle Linear/Circular Format" onClick={() => {
                const format = (cgv.format === 'circular') ? 'linear' : 'circular';
                cgv.settings.update({ format: format });
                cgv.draw();
            }}></div>,
            <div className="cgv-btn" id="btn-invert-colors" title="Invert Map Colors" onClick={() => cgv.invertColors()}></div>,
            <div className="cgv-btn" id="btn-download" title="Download Map PNG" onClick={() => {
                const height = 2000;
                // Here we adjust the width to be proportional to the height
                const width = cgv.width / cgv.height * height;
                cgv.io.downloadImage(width, height, 'cgview_map.png');
            }}></div>,
            <div className="cgv-btn" id="btn-toggle-labels" title="Toggle Labels" onClick={() => {
                cgv.annotation.update({visible: !cgv.annotation.visible});
                cgv.draw();
            }}></div>,
            <div className="cgv-btn" id="btn-animate" title="Start/Stop Animation" onClick={() => cgv.isAnimating ? cgv.stopAnimate() : cgv.animate()}></div>
        ];
        setButtons(newButtons);

        cgv.draw();
    }, [cgvData]);

    // Helper to add click handlers to buttons
    

    return (
        
        <div>
            <div id="my-viewer"></div>
            <div className="cgv-controls">
                {buttons}
            </div>
        </div>
        
    )
}

export default CgView;